import defaultAxios from "lib/http/http.common"
import {ApiResponse, PageableListResponse} from "api/common/response"
import {PathTrackingResponse} from "dto/path-tracking/path-tracking"
import {RecentLogCounter} from "dto/path-tracking/log-counter"
import FileSaver from "file-saver";

const findByEuiAndDate = (eui: string, date: string, page: number, size: number) => {
    // return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking/${eui}/${date}?page=${page}&size=${size}&sort=id,desc`)
    return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking/${eui}/${date}?page=${page}&size=${size}`)
}
const findByImpactEuiAndDate = (eui: string, page: number, size: number) => {
    return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking/${eui}/status/impact?page=${page}&size=${size}`)
}

const findAll = (page: number, size: number) => {
    return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking?page=${page}&size=${size}`)
}
const findAllByEmergency = (page: number, size: number) => {
    return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking/status/impact?page=${page}&size=${size}`)
}

const findAllByEuiContains = (eui: string, page: number, size: number) => {
    return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking/search/${eui}?page=${page}&size=${size}`)
}

const findAllByEuiAndEmergency = (eui: string, page: number, size: number) => {
    return defaultAxios.get<ApiResponse<PageableListResponse<PathTrackingResponse>>>(`/path-tracking/${eui}/impact?page=${page}&size=${size}`)
}

const findRecentLogCounter = (period: number) => {
    return defaultAxios.get<ApiResponse<RecentLogCounter[]>>(`/device/log-counter/recent/${period}`)
}
export const downloadEmergencyExcel = async () => {
    try {
        const response = await defaultAxios.get('/path-tracking/excel', {
            responseType: 'blob', // Important
        });

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, 'em-log.xlsx');
    } catch (error) {
        console.error('Error downloading the Excel file', error);
    }
};


export const PathTrackingApi = {
    findByEuiAndDate,
    findByImpactByEui: findByImpactEuiAndDate,
    findAll,
    findAllByEuiContains,
    findRecentLogCounter,
    findAllByEuiAndEmergency,
    findAllByEmergency
}